import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {QuestionImageSize} from 'common/constants/survey';

import MarkdownText from '../MarkdownText';

import {OptionContentProps} from './OptionContent.types';

import './OptionContent.scss';

const cnOptionContent = cn('OptionContent');

const OptionContent: FC<OptionContentProps> = ({label, image}) => {
    return (
        <div className={cnOptionContent()}>
            {image && (
                <img
                    src={image[QuestionImageSize.cropped324x180]}
                    className={cnOptionContent('Image')}
                    alt=""
                />
            )}
            <MarkdownText
                text={label}
                variant="body-2"
                className={cnOptionContent('Text', {withImage: Boolean(image)})}
                title={label}
            />
        </div>
    );
};

export default OptionContent;
